import { render, staticRenderFns } from "./ImportCpp.vue?vue&type=template&id=70cce89c&scoped=true"
import script from "./ImportCpp.vue?vue&type=script&lang=js"
export * from "./ImportCpp.vue?vue&type=script&lang=js"
import style0 from "./ImportCpp.vue?vue&type=style&index=0&id=70cce89c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cce89c",
  null
  
)

export default component.exports